__turbopack_context__.v({
  "body": "ProductStory-module-scss-module__nRdZ_q__body",
  "container": "ProductStory-module-scss-module__nRdZ_q__container",
  "content": "ProductStory-module-scss-module__nRdZ_q__content",
  "image": "ProductStory-module-scss-module__nRdZ_q__image",
  "imageAlignRight": "ProductStory-module-scss-module__nRdZ_q__imageAlignRight",
  "imageContain": "ProductStory-module-scss-module__nRdZ_q__imageContain",
  "imagePanel": "ProductStory-module-scss-module__nRdZ_q__imagePanel",
  "mediaReversed": "ProductStory-module-scss-module__nRdZ_q__mediaReversed",
  "readMoreButton": "ProductStory-module-scss-module__nRdZ_q__readMoreButton",
  "section": "ProductStory-module-scss-module__nRdZ_q__section",
  "textPanel": "ProductStory-module-scss-module__nRdZ_q__textPanel",
  "title": "ProductStory-module-scss-module__nRdZ_q__title",
  "titleAccent": "ProductStory-module-scss-module__nRdZ_q__titleAccent",
});
